import { openDB } from "idb";
// Open only from authenticated editor flows; the Guest viewer never calls this module.
const db = () =>
  openDB("51time-private-work", 1, {
    upgrade(db) {
      db.createObjectStore("drafts");
      db.createObjectStore("outbox");
    },
  });
export async function getDraft(user: string, map: string) {
  return (await db()).get("drafts", `${user}:${map}`);
}
export async function putDraft(user: string, map: string, value: unknown) {
  return (await db()).put("drafts", value, `${user}:${map}`);
}
export async function clearDraft(user: string, map: string) {
  return (await db()).delete("drafts", `${user}:${map}`);
}
export async function queueFeedback(user: string, value: { clientId: string }) {
  return (await db()).put(
    "outbox",
    { user, payload: value },
    `${user}:${value.clientId}`,
  );
}
export async function feedbackQueue(user: string) {
  return (await (await db()).getAll("outbox")).filter(
    (row) => row.user === user,
  );
}
export async function clearFeedback(user: string, id: string) {
  return (await db()).delete("outbox", `${user}:${id}`);
}
